module.exports = __webpack_public_path__ + "lato-heavy-italic-38d2399f6c10d8ba1d8d45ba0c440ad5.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/lato-heavy-italic/lato-heavy-italic.woff
// module id = 1065
// module chunks = 0